export default __webpack_public_path__ + "media/design-system/icon/assets/brand/MD/check-cf2e252afeb0f58e6a5b835020bcb81d.svg";